<template>
  <div class="container-fluid text-secondary">
    <loading :active.sync="isLoading"
        :can-cancel="true"
        :on-cancel="onCancel"
        :is-full-page="fullPage"></loading>
    <div class="row title-card">
      <div class="col-10 text-left"><b-link @click="backButton()"><span><icon name="cog" scale="2.5" spin v-show="spinner"></icon><icon name="arrow-circle-left" scale="2.5" v-show="back"></icon></span></b-link> <h4>{{ check.nm_store }}</h4></div>
      <div class="col-2 text-right"><b-link class="text-secondary" :to="{ name: 'home' }"><icon name="times" scale="2"></icon></b-link></div>
    </div>
    <div class="row no-gutters">
      <div class="col-9 col-sm-10 col-md-10 col-lg-8 col-xl-7 offset-lg-1 offset-xl-2"><h5>{{ check.nm_check }}</h5></div>
      <div class="col-3 col-sm-2 col-md-2 col-lg-2 col-xl-1 text-right"><b-link class="text-secondary" :to="{ name: 'history', params: { store: check.id_store, check: check.id_check }}"><icon name="info-circle" scale="2"></icon></b-link></div>
    </div>
    <div class="row no-gutters">
      <div class="col-lg-10 col-xl-8 offset-lg-1 offset-xl-2">
          <p v-html="check.ds_check.replace(/(?:\r\n|\r|\n)/g, '<br />')"></p>
      </div>
    </div>

    <!-- Check Novo -->
    <template v-if="check.status == 'novo'">
      <div class="row no-gutters justify-content-center text-white text-center text-uppercase mt-4 botoes">
        <div class="col-4 col-sm-4 col-md-3 col-lg-2 col-xl-1 bg-success pt-2" @click="checkOk()"><icon name="check-circle" scale="3"></icon><br><p>Tudo<br>Certo</p></div>
        <div class="col-4 col-sm-4 col-md-3 col-lg-2 col-xl-1 bg-danger pt-2" @click="checkFail()"><icon name="times-circle" scale="3"></icon><br><p>Tem<br>Problema<br>Aqui</p></div>
        <div class="col-4 col-sm-4 col-md-3 col-lg-2 col-xl-1 bg-warning pt-2" @click="checkOpen()"><icon name="exclamation-circle" scale="3"></icon><br><p>Apenas<br>Considerações</p></div>
      </div>
    </template>

    <!-- Check Aberto -->
    <template v-if="check.status == 'aberto'">
      <div class="row no-gutters">
        <div class="col-lg-10 col-xl-8 offset-lg-1 offset-xl-2 bg-white text-white mensagens">
          <ul class="m-2">
            <li v-if="messages == 0" ><p class="text-secondary text-center">SEM MENSAGENS</p></li>
            <li v-for="(message, index) in messages" v-bind:key="'m-'+index" v-bind:class="message.align" v-bind="mainProps">
              <p class="p-0 m-0"><small>{{ message.dt_message }} - {{ message.nm_sender }}</small></p>
              <p class="p-0 m-0" v-html="message.ds_message.replace(/(?:\r\n|\r|\n)/g, '<br />')" v-if="message.tp_message == 'txt'"></p>
              <p class="p-0 m-0" v-if="message.tp_message == 'img'">
                <img :src="message.ds_message" class="img-fluid" v-bind="mainProps" @click="openImg(message.ds_message)">
              </p>
              <p class="p-0 m-0" v-if="message.tp_message == 'arq'" title="Download">
                <a v-bind:href="message.ds_message" target="_blank">
                  <icon name="download" scale="4" class="align-middle"></icon>
                </a>
              </p>
            </li>
          </ul>
        </div>
      </div>
      <div class="row no-gutters mt-2">
        <div class="col-lg-10 col-xl-8 offset-lg-1 offset-xl-2">
          <div class="input-group mb-3">
            <textarea v-model="newMessage" class="form-control" placeholder="Mensagem" id="newMessage" rows="3" maxlength="500" required></textarea>
            <div class="input-group-append">
                <span class="input-group-text bg-secondary text-light btm-send" @click="sendMessage()">
                    <icon name="caret-right" scale="1"></icon>
                </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row no-gutters mt-0">
        <input type="file" accept="*" id="camera" class="d-none" @change="onFileChange">
        <div class="col-6 col-sm-6 col-md-6 col-lg-5 col-xl-4  offset-lg-1 offset-xl-2" >
            <button v-if="level == 'supervisor'" type="submit" class="btn btn-success text-white" @click="checkClose(0)">Tudo Certo</button>
            <button v-if="level == 'supervisor'" type="submit" class="btn bg-danger text-white" @click="checkClose(1)">Tem Problema Aqui</button>
        </div>
        <div class="col-6 col-sm-6 col-md-6 col-lg-5 col-xl-4 text-right">
            <button class="btn btn-secondary btn-camera" @click="openCamera()">
              <icon name="upload" scale="1.5"></icon>
            </button>
        </div>

      </div>

      <!-- Modal Img -->
      <b-modal ref="myModalRef" hide-footer >
        <div class="d-block text-center">
          <img :src="openImage" class="img-fluid">
        </div>
      </b-modal>
    </template>
  </div>
</template>

<script>
import { http } from '../http';
import swal from 'sweetalert2';
import Icon from 'vue-awesome';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {
        Icon,
        Loading
  },
  data () {
    return {
      level: localStorage.getItem('level'),
      admin: localStorage.getItem('admin'),
      spinner: true,
      back: false,
      check: [],
      messages: [],
      newMessage: null,
      image: '',
      filename: '',
      imagens: [],
      mainProps: { blank: true, width: 100, height: 100, class: 'm1' },
      openImage: '',
      isLoading: false,
      fullPage: true
    }
  },
  beforeCreate: function() {
    // Verifica se existe o item token no localStorage.
    if (!localStorage.getItem('token')) this.$router.push('home');
  },
  mounted() {
    // Verifica se está definida as informações dos parâmetros que são apagadas em caso de reload da página.
    if (this.$route.params.store && this.$route.params.check) {
      // Armazenando a loja e o check no localStorage para o caso de reloads.
      localStorage.setItem('id_store', this.$route.params.store)
      localStorage.setItem('id_check', this.$route.params.check)
      // Supervisor
      if (localStorage.getItem('level') == 'supervisor') {
        // Iniciar o check.
        http.get('/checks/iniciar/'+this.$route.params.store+'/'+this.$route.params.check).then(response => {
          // Verifica se a requisição para iniciar o check é o mesmo que o WS autoriza.
          this.spinner = false;
          this.back = true;
          this.check = response.data;
          http.get('/message/all/'+this.admin+'/'+response.data.id_result).then(response => {
            this.messages = response.data
          })
        })
      }

      // Loja
      if (localStorage.getItem('level') == 'store') {
        // Iniciar o check.
        http.get('/checks/iniciar/'+this.$route.params.store+'/'+this.$route.params.check).then(response => {
          // Verifica se a requisição para iniciar o check é o mesmo que o WS autoriza.
          this.spinner = false;
          this.back = true;
          this.check = response.data;
          http.get('/message/all/'+this.admin+'/'+response.data.id_result).then(response => {
            this.messages = response.data
          })
        })
      }
    }
    else {
      // Verifica se existe a última loja visitada no localStorage.
      if (localStorage.getItem('id_store') && localStorage.getItem('id_check')) {
        // Supervisor
        if (localStorage.getItem('level') == 'supervisor') {
          // Iniciar o check.
          http.get('/checks/iniciar/'+localStorage.getItem('id_store')+'/'+localStorage.getItem('id_check')).then(response => {
            // Verifica se a requisição para iniciar o check é o mesmo que o WS autoriza.
            this.spinner = false;
            this.back = true;
            this.check = response.data;
            http.get('/message/all/'+this.admin+'/'+response.data.id_result).then(response => {
              this.messages = response.data
            })
          })
        }

        // Loja
        if (localStorage.getItem('level') == 'store') {
          // Iniciar o check.
          http.get('/checks/iniciar/'+localStorage.getItem('id_store')+'/'+localStorage.getItem('id_check')).then(response => {
            // Verifica se a requisição para iniciar o check é o mesmo que o WS autoriza.
            this.spinner = false;
            this.back = true;
            this.check = response.data;
            http.get('/message/all/'+this.admin+'/'+response.data.id_result).then(response => {
              this.messages = response.data
            })
          })
        }
      }
    }
  },
  methods: {
    checkOk () {
      // Requisição para gravar o check como ok.
      http.post('/checks/salvar', { id_store: this.check.id_store, id_check: this.check.id_check, nm_check: this.check.nm_check, vl_result: '0', st_result: '1' })
        .then(response => {
          this.backButton()
        })
    },
    checkFail () {
      this.isLoading = true;
      // Requisição para gravar o check como com problemas.
      http.post('/checks/salvar', { id_store: this.check.id_store, id_check: this.check.id_check, nm_check: this.check.nm_check, vl_result: '1', st_result: '0' })
        .then(response => {
          this.isLoading = false;
          http.get('/checks/iniciar/'+this.check.id_store+'/'+this.check.id_check).then(response => {
            // Verifica se a requisição para iniciar o check é o mesmo que o WS autoriza.
            this.spinner = false;
            this.check = response.data;
            this.newMessage = 'Check iniciado com problemas.';
            this.sendMessage();
          })
        })
    },
    checkOpen () {
      this.isLoading = true;
      // Requisição para gravar o check com considerações.
      http.post('/checks/salvar', { id_store: this.check.id_store, id_check: this.check.id_check, nm_check: this.check.nm_check, vl_result: '0', st_result: '0' })
        .then(response => {
          this.isLoading = false;
           http.get('/checks/iniciar/'+this.check.id_store+'/'+this.check.id_check).then(response => {
              // Verifica se a requisição para iniciar o check é o mesmo que o WS autoriza.
              this.spinner = false;
              this.check = response.data;
              this.newMessage = 'Check iniciado com considerações.';
              this.sendMessage();
           })
        })
    },
    checkClose (vl_result) {
      // Requisição para encerrar o check.
      http.post('/checks/encerrar', { id_result: this.check.id_result, vl_result: vl_result})
        .then(response => {
          this.backButton()
        })
        .catch(error => {
          swal({
            type: 'error',
            title: 'Erro...',
            text: error.response.data.mensagem
          })
        })
    },
    backButton () {
      this.$router.go(-1)
    },
    sendMessage () {
      // Verifica se o campo de mensagem foi preenchido.
      if(this.newMessage == null) {
        swal({ type: 'error', title: 'Erro...', text: 'Digite uma mensagem.' })
        return false;
      }
      // JSON a ser enviado para o webservice.
      let json = this.getJson();
      // Requisição para salvar a mensagem.
      http.post('/message/save/'+this.check.id_result, json)
      .then(response => {
        http.get('/message/all/'+this.admin+'/'+this.check.id_result).then(response => {
          this.messages = response.data;
          this.sendNotification(json);
        });
      })
      .catch(error => {
        swal({
          type: 'error',
          title: 'Erro...',
          text: 'Não foi possível salvar a mensagem.'
        })
      })
    },
    openCamera() {
      document.getElementById('camera').click();
    },
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;
      this.createImage(files[0]);
    },
    createImage(file) {
      let reader = new FileReader();
      let vm = this;
      reader.onload = (e) => {
        vm.image = e.target.result;
        this.sendPhoto();
      };
      reader.readAsDataURL(file);
      vm.filename = file.name;
    },
    sendPhoto () {
      this.isLoading = true;
      var json  = { id_result: this.check.id_result, nm_image: this.filename, nm_sender: localStorage.getItem('nm_user'), admin: localStorage.getItem('admin'), dt_image: new Date().toLocaleString(), image: this.image }
      http.post('/image/save', json)
      .then(response => {
         http.get('/message/all/'+this.admin+'/'+this.check.id_result).then(response => {
            this.messages = response.data;
            this.isLoading = false;
            let json = this.getJson();
            this.sendNotification(json);
         })
      })
      .catch(error => {
        swal({
          type: 'error',
          title: 'Erro...',
          text: 'Imagem não salva.'
        })
      })
    },
    getImage () {
        http.get('/image/all/'+this.check.id_result).then(response => {
            this.imagens = response.data;
         })

    },
    openImg (url) {
        this.openImage = url;
        this.$refs.myModalRef.show()
    },
    getJson(){
        var json = { id_result: this.check.id_result, ds_message: this.newMessage, nm_sender: localStorage.getItem('nm_user'), id_store: this.check.id_store, admin: localStorage.getItem('admin'), user: localStorage.getItem('user'), nm_check: this.check.nm_check}
        // Limpando o campo de mensagem.
        this.newMessage = null
        return json;
    },
    sendNotification(json){
        http.post('/message/notification/'+this.check.id_result, json).then(response => {
        });
    }
  }
}
</script>

<style scoped>
.container-fluid { min-height:100vh; background:#E0E0E0; }
.container-fluid .title-card { padding:20px 0; }
.container-fluid .title-card span { display:block; width:40px; height:40px; float:left; border-radius:20px; font-size:20px; color:#E0E0E0; background:#6c757d; line-height:40px; text-align:center; margin-right:24px; }
.container-fluid .title-card h4 { font-size:1.5em; line-height:40px; }

.botoes div { border:2px solid #E0E0E0; cursor:pointer; }
.botoes div p { font-size:0.8rem; margin-top:6px; }

.mensagens {height:50vh; overflow: auto; display: flex; flex-direction: column-reverse; border: 1px solid; }
.mensagens ul { list-style:none; padding:0; }
.mensagens ul li { padding:10px; margin-bottom:10px; position:relative; border-radius:5px; }
.mensagens ul li.text-left { background:#DC3545; margin-left:16px; margin-right:10%; }
.mensagens ul li.text-left:after { content:'';	position:absolute; left:0; top:10px; width:0; height:0; border:20px solid transparent; border-right-color:#DC3545; border-left:0; border-top:0; margin-left:-20px; }
.mensagens ul li.text-right { background:#17A2B8; margin-left:10%; margin-right:16px; }
.mensagens ul li.text-right:after { content:'';	position:absolute; right:0;	top:10px; width:0; height:0;	border:20px solid transparent; border-left-color:#17A2B8; border-right:0; border-top:0; margin-right:-20px; }
.mensagens ul li p { font-size:15px; }

.btn-camera { padding:10px; line-height:10px; }
//.btm-send {  background:#6c757d !important;}
</style>



// WEBPACK FOOTER //
// src/components/Check.vue